/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

import Framework, { BaseService } from '@greenville/framework';
import * as constants from '../../constants/ServiceConstants';
import utils from '../../../../common/utils';

export default class GetModelPropertiesService extends BaseService {
  constructor() {
    super(constants.GET_MODEL_PROPERTIES, 'modelPropertiesStatus');
  }

  async handleEvent() {
    const { isStackB } = utils.getStackBParams();

    if (isStackB) {
      const enhancedHeaders = await utils.resolveStackBHeaders({});
      return this.getClient('aiadminstackb').get('/models/properties', { headers: enhancedHeaders });
    }
    return this.getClient('aiadmin').get('/models/properties');
  }

  handleResponse(response) {
    const { data } = response;
    if (data && data.success) {
      Framework.getStoreRegistry().getStore('modelPropertiesMappingModel').setModelProperties(data.data);
    } else {
      Framework.getStoreRegistry().getStore('modelPropertiesMappingModel').setModelProperties([]);
    }
  }

  handleError() {
    Framework.getStoreRegistry().getStore('modelPropertiesMappingModel').setError('Failed to fetch model properties');
  }
}
